import styled from "styled-components";
import { device } from "../../styles/devices";

export const ContactTaskMeContent = styled.div`
    h3{
        font-size: 1.3rem;
        font-weight: var(--font-medium);
        line-height: 2rem;
        text-align: center;
        margin-bottom: 1rem;
        color: var(--color-black);

        @media ${device.mobile}{
            text-align: initial;
        }
    }

`;
export const ContactTaskMeItem = styled.div`
    background-color: var(--color-white);
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 1rem;
    padding: 1.5rem 2rem;
    text-align: center;
    transition: background-color .3s;
    box-shadow: 0 1px 8px rgba(0,0,0,0.15);
    cursor: pointer;

    @media ${device.mobile}{
        padding: 1.5rem 1rem;
    }

    &:hover{
        background-color: var(--color-white-hover);
    }

    &:not(:last-child){
        margin-bottom: 2rem;

        @media ${device.mobile}{
            margin-bottom: 1.5rem;
        }
    }

    i{
        display: block;
        font-size: 1.5rem;
        color: var(--color-title);
        margin-bottom: .5rem;
    }

    h4{
        font-size: 1rem;
        font-weight: var(--font-medium);
        line-height: 1.5rem;
        color: var(--color-title);
        margin-bottom: .5rem;
    }

    p{
        font-size: 1rem;
        font-weight: var(--font-normal);
        line-height: 1.5rem;
        color: var(--color-text);
        margin-bottom: 1rem;
    }

    a{
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 1rem;
        font-weight: var(--font-medium);
        line-height: 1.5rem;
        color: var(--color-title);
        transition: all .3s;
        position: relative;

        &:hover{
            color: var(--color-black-hover)

            i{
                transform: translate(0.25rem);
            }
        }

        i{
            font-size: 1.3rem;
            margin-bottom: 0;
            transition: .3s;
        }
    }
`;